import React from "react";
import { Grid } from "@mui/material";
import MerchantRequest from "./requestBusiness";
import AppCard from "../../components/dashboard.js/AppCard";
import Loader from "../../components/Loader";
import Iconify from '../../components/Iconify';
import HTTPManager from "../../utils/httpRequestManager";
const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class CNDashboard extends React.Component{
    httpmanager = new HTTPManager();
    constructor(){
        super();
        this.state={
            userdetail:{}, 
            isLoading: false, 
            usermetrics:{
                totalcount: 0,
                waitingcount: 0,
                approvedcount:0,
                rejectedcount:0
            }
        }
        this.loadData = this.loadData.bind(this);
        this.getEmpMetrics = this.getEmpMetrics.bind(this);
    }
    componentDidMount(){ 
        this.loadData()
    }

    loadData(){

        var details = window.localStorage.getItem("userdetail") || ''
        if(details !== ''){
            this.setState({userdetail: JSON.stringify(details)}, ()=>{
                this.getEmpMetrics();
            })
        }
    }

    getEmpMetrics(){
        this.setState({isLoading: true}, ()=>{
            this.httpmanager.getRequest(`/cnEmployees/getMetrics`).then(response=>{
                //console.log(response.data)
                if(response.data.totalcount !== undefined){
                    this.setState({usermetrics:response.data, isLoading: false}, ()=>{
                        //console.log(this.state.usermetrics)
                    })
                }
                else{ 
                this.setState({isLoading:false, usermetrics:{
                    customerCount: 0,
                    empCount: 0,
                    itemsCount:0,
                    categoryCount:0
                }})
                }
            }).catch(e=>{
                this.setState({isLoading:false, usermetrics:{
                    totalcount: 0,
                    waitingcount: 0,
                    approvedcount:0,
                    rejectedcount:0
                }})
            })
        })
    }

    render(){
        return <div> 
            {this.state.isLoading && <Loader />}
           {!this.state.isLoading && <Grid container> 
            <Grid item xs={12} sm={6} md={3}>
                <AppCard Icon={getIcon("mdi:account-group")}  Text="Total Merchants" value={this.state.usermetrics.totalcount}/>
              </Grid>
              
            <Grid item xs={12} sm={6} md={3}>
                <AppCard Icon={getIcon("mdi:clock-time-eight")} Text="Waiting Merchants"   value={this.state.usermetrics.waitingcount}/>
              </Grid>
              
            <Grid item xs={12} sm={6} md={3}>
                <AppCard Icon={getIcon("mdi:check-decagram")} Text="Approved Merchants"   value={this.state.usermetrics.approvedcount}/>
              </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <AppCard Icon={getIcon("mdi:check-decagram")}  Text="Rejected Merchants"  value={(this.state.usermetrics.rejectedcount)}/>
              </Grid> 
            </Grid>}

            {this.state.requestNewBusiness && <>
                <MerchantRequest />
            </>}

        </div>
    }
}